'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo, Fragment } from 'react';
import { MANIFEST_FONTS } from '../../../core/manifest/fonts.js';
import { isNonNullish } from '../../../core/utilities/is.utils.js';
import { getSameKeyValueMapForManifest, manifestResolve } from '../../../core/utilities/manifest.utils.js';
import { useSwanHeadConfig } from './head.hook.js';
import { SwanPathTypeEnum, SwanAssetFolders } from '../../../core/types/enums.js';
import { SWAN_BASE_CDN_URL } from '../../../core/constants/domains.js';

var r;
const SWAN_FONT_KEY_MAP = getSameKeyValueMapForManifest(MANIFEST_FONTS);
var SwanFontNameEnum;
(r = SwanFontNameEnum || (SwanFontNameEnum = {})).Graphik = "Graphik", r.GraphikMedium = "GraphikMedium", r.GraphikRegular = "GraphikRegular", r.Tiempos = "Tiempos", r.TiemposRegular = "TiemposRegular", r.Primary = "Graphik", r.PrimaryBold = "GraphikMedium", r.PrimaryRegular = "GraphikRegular", r.Secondary = "Tiempos", r.SecondaryRegular = "TiemposRegular";
const SwanFonts = ({ fontNames: r, swanPathType: n, swanBaseUrl: i, swanTenant: s, swanLocale: l, renderWith: m = Fragment, renderStyleContentAsChildren: p })=>{
    let { swanBaseUrl: f, swanPathType: c } = useSwanHeadConfig(i, n, s, l), [g, h] = useMemo(()=>getSwanFontRenderConfig(r || void 0, c, f), [
        r,
        c,
        f
    ]);
    return jsxs(m, {
        children: [
            g.map((r)=>jsx("link", {
                    rel: "preload",
                    crossOrigin: "anonymous",
                    as: "font",
                    href: r
                }, r)),
            p ? jsx("style", {
                type: "text/css",
                children: h
            }, "swan-font-config-children") : jsx("style", {
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: h
                }
            }, "swan-font-config-inner-html")
        ]
    });
};
function getSwanFontUrl(r, e, a) {
    return manifestResolve(MANIFEST_FONTS, r, SwanAssetFolders.FONTS, e, a);
}
function getSwanFontRenderConfig(r = [
    "Graphik"
], e = SwanPathTypeEnum.hashed, a = SWAN_BASE_CDN_URL) {
    return [
        r.flatMap((r)=>getPreLoadUrlsForFontName(r, e, a)).filter(isNonNullish),
        r.map((r)=>getSwanFontStyleConfig(r, e, a)).join('\n')
    ];
}
function getPreLoadUrlsForFontName(r, e, a) {
    switch(r){
        case "Graphik":
        case "Graphik":
            return [
                "GraphikRegular",
                "GraphikMedium"
            ].flatMap((r)=>getPreLoadUrlsForFontName(r, e, a));
        case "GraphikMedium":
        case "GraphikMedium":
            return [
                getSwanFontUrl(SWAN_FONT_KEY_MAP.graphicMedium2, e, a)
            ];
        case "GraphikRegular":
        case "GraphikRegular":
            return [
                getSwanFontUrl(SWAN_FONT_KEY_MAP.graphicRegular2, e, a)
            ];
        case "Tiempos":
        case "Tiempos":
            return [
                "TiemposRegular"
            ].flatMap((r)=>getPreLoadUrlsForFontName(r, e, a));
        case "TiemposRegular":
        case "TiemposRegular":
            return [
                getSwanFontUrl(SWAN_FONT_KEY_MAP.tiemposRegular2, e, a)
            ];
        default:
            return [
                null
            ];
    }
}
function getSwanFontStyleConfig(r, e, a) {
    let fontUrlForKey = (r)=>getSwanFontUrl(r, e, a) || '';
    switch(r){
        case "Graphik":
        case "Graphik":
            return [
                "GraphikRegular",
                "GraphikMedium"
            ].map((r)=>getSwanFontStyleConfig(r, e, a)).join('\n');
        case "Tiempos":
        case "Tiempos":
            return [
                "TiemposRegular"
            ].map((r)=>getSwanFontStyleConfig(r, e, a)).join('\n');
        case "GraphikMedium":
        case "GraphikMedium":
            return `
        @font-face {
          font-family: 'Graphik';
          font-stretch: normal;
          font-style: normal;
          font-weight: 700;
          font-display: swap;
          src: url('${fontUrlForKey(SWAN_FONT_KEY_MAP.graphicMedium2)}') format('woff2'),
            url('${fontUrlForKey(SWAN_FONT_KEY_MAP.graphicMedium)}') format('woff');
        }`;
        case "GraphikRegular":
        case "GraphikRegular":
            return `
      @font-face {
        font-family: 'Graphik';
        font-stretch: normal;
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('${fontUrlForKey(SWAN_FONT_KEY_MAP.graphicRegular2)}') format('woff2'),
          url('${fontUrlForKey(SWAN_FONT_KEY_MAP.graphicRegular)}') format('woff');
      }`;
        case "TiemposRegular":
        case "TiemposRegular":
            return `
      @font-face {
        font-family: 'Tiempos';
        font-stretch: normal;
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('${fontUrlForKey(SWAN_FONT_KEY_MAP.tiemposRegular2)}') format('woff2');
      }
      `;
        default:
            return "";
    }
}

export { SWAN_FONT_KEY_MAP, SwanFontNameEnum, SwanFonts, getSwanFontRenderConfig, getSwanFontUrl };
